// extracted by mini-css-extract-plugin
export default {"headerInfo":"TransactionTable_headerInfo__vLErw"};